/**
 * ProbabilityOfSuccess component module.
 * @module shared/components/ProbabilityOfSuccess
 */
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {_openModal} from '../../../../shared/reducers/modals';
import useSWR from 'swr';
import axiosInstance from '../../../../shared/utils/axios';
import {mgpLaunch} from '../../../sections/analyze/Mgp';
import {LoadingSpinner, Carousel, MgpPoS} from '../../../../shared';
import {isEntitled} from '../../../../shared/reducers/user';
import styled from 'styled-components/macro';
import {withSize} from 'react-sizeme';

import EMoneyProbabilityOfSuccessBox from '../../analyze/EMoneyProbabilityOfSuccessBox';

const _Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const ProbabilityOfSuccess = (props) => {
  const {size, householdID, session, openModal} = props;
  const entitledMgp = isEntitled([{group: 'financialPlanning', feature: 'mgp', access: 'r'}]);
  const entitledEMoney = isEntitled([{group: 'financialPlanning', feature: 'emoney', access: 'r'}]);
  const [analyzingMgpPoS, setAnalyzingMgpPoS] = useState();
  const [mgpPoS, setMgpPoS] = useState({text: 'Financial Plan Confidence Level', percent: '?'});
  const {data: queue} = useSWR(entitledEMoney && `/households/${householdID}/emoney/status`);
  const {data: info} = useSWR(entitledEMoney && `/households/${householdID}/emoney`);

  useEffect(() => {
    if (householdID && !analyzingMgpPoS && session.profile.consent && session.profile.consent.includes('mgp')) {
      setAnalyzingMgpPoS(true);
      axiosInstance.post(`/households/${householdID}/probability`)
        .then(res => {
          setMgpPoS(res.data);
          setAnalyzingMgpPoS(false);
        })
        .catch(err => {
          if (err.response?.data?.error?.code === 105) {
            setMgpPoS({text: 'No Plan', percent: '--'});
          } else {
            setMgpPoS({text: 'Error communicating<br/>with MoneyGuidePro', percent: 'err'});
          }
          setAnalyzingMgpPoS(false);
        });
    }
  }, [householdID]);

  if (!householdID || analyzingMgpPoS) {
    return <LoadingSpinner/>;
  }

  return <_Wrapper>
    <Carousel height={'100%'} childMinWidth={'200px'} childMinHeight={'200px'}>
      {(entitledMgp && !analyzingMgpPoS)
        ? <MgpPoS action={() => mgpLaunch(householdID, openModal)}
                  probabilityOfSuccess={mgpPoS}
                  showLogo={size.height > 210}
                  layoutSize={'sm'}/> : null}
      {entitledEMoney && !info && <LoadingSpinner/>}
      {entitledEMoney && info && <EMoneyProbabilityOfSuccessBox householdId={householdID}
                                                                openModal={openModal}
                                                                queue={queue}
                                                                info={info}
                                                                layoutSize={'sm'}/>}
    </Carousel>
  </_Wrapper>;
};

const mapStateToProps = state => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withSize({monitorHeight: true, monitorWidth: true})(ProbabilityOfSuccess));

ProbabilityOfSuccess.propTypes = {
  /**
   * size of container
   */
  size: PropTypes.shape({
    height: PropTypes.number,
    width: PropTypes.number,
  }),
  openModal: PropTypes.func,
  householdID: PropTypes.number.isRequired,
  session: PropTypes.object,
  editing: PropTypes.bool,
};
